import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar el token a todas las peticiones
axiosInstance.interceptors.request.use(
  (config) => {
    console.log('=== DEBUG AXIOS REQUEST ===');
    const token = localStorage.getItem('token');
    console.log('Token en localStorage:', token);
    
    if (token) {
      const formattedToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      config.headers.Authorization = formattedToken;
      console.log('Token formateado:', formattedToken);
    }
    
    console.log('Headers finales:', config.headers);
    return config;
  },
  (error) => {
    console.error('Error en interceptor de request:', error);
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Solo redirigir si NO estamos en la página de login
    const isLoginPage = window.location.pathname === '/' || window.location.pathname === '/login';

    if (error.response?.status === 401 ||
        (error.response?.status === 422 && error.response?.data?.msg?.includes('Authorization'))) {

      // Si hay error de autenticación y NO estamos en login, limpiar token y redirigir
      if (!isLoginPage) {
        localStorage.removeItem('token');
        localStorage.removeItem('userRol');
        localStorage.removeItem('userName');
        window.location.href = '/';
      }
      // Si estamos en login, simplemente rechazar el error para que el componente lo maneje
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 